import React from 'react';
import { usePresence } from '../utils/presence';
import { presenceText } from './LastSeen';
import '../styles/presence.css';

/**
 * The coloured dot on a colleague's picture, Teams-style: green available,
 * yellow away, red in a call, purple on leave, a grey ring offline. Nothing at
 * all until their presence is known.
 */
export const PresenceDot = ({ userId, small = false }) => {
    const presence = usePresence(userId);
    if (!userId || !presence?.status) return null;
    const text = presenceText(presence);
    return (
        <span
            className={`presence-dot is-${presence.status}${small ? ' is-small' : ''}`}
            title={text}
            role="img"
            aria-label={text}
        />
    );
};

/** A picture with that dot in its bottom-right corner. */
const WithPresence = ({ userId, small, children }) => (
    <span className="presence-wrap">
        {children}
        <PresenceDot userId={userId} small={small} />
    </span>
);

export default WithPresence;
